import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";

/*  LAZY PAGE IMPORTS */
const Homepage = lazy(() => import("./pages/homepage"));
const ServicesPage = lazy(() => import("./pages/services"));
const ContactPage = lazy(() => import("./pages/contact"));
const About = lazy(() => import("./pages/about"));
const Footer = lazy(() => import("./components/ui/Footer"));
const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />

        <Suspense
          fallback={
            <div className="min-h-screen flex items-center justify-center text-text-secondary">

            </div>
          }>
          <RouterRoutes>
            <Route path="/" element={<Homepage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about" element={<About />} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
          <Footer />
        </Suspense>

      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
